
<template>

  <div class="ui text container">
    <div class="ui segments">

      <!-- Website logo -->
      <div class="ui segment">
        <a href="/">
          <img width="75%" class="ui centered image" src="@/assets/images/7asanat-logo.png" />
        </a>
      </div>

      <div class="ui center aligned segment">
        <div class="ui centered grid">

          <div class="row">
            <div class="column">

              <h3 class="ui almarai center aligned primary header">
                أدخل اسم (أو أسماء) المهدى لهـ(ـم)
              </h3>

              <h3 class="ui almarai center aligned grey header">
                أمثلة:
                <br><br>
                - المرحوم فلان الفلاني
                <br><br>
                - فلان الفلاني، فلان الفلاني
              </h3>

              <h3 class="ui almarai center aligned primary header">
                ثم اضغط على زر إنشاء الختمة
              </h3>

              <h3 class="ui almarai center aligned red header">
                قم بنسخ رابط صفحة الختمة بعد أن تظهر
              </h3>

            </div>
          </div>

          <div class="row">
            <div class="column">

              <div class="ui almarai fluid input">
                <input type="text" placeholder="إهداء الختمة" v-model="ehdaa">
              </div>

            </div>
          </div>

          <div class="row">
            <button class="ui almarai primary button" @click="createKhatma()">
              أنشئ الختمة
            </button>
          </div>

        </div>

      </div>

      <div class="ui center aligned segment">
        <a class="ui large english label" href="/">
          <span class="ui almarai text">عودة إلى الصفحة الرئيسية</span>
          <i class="undo alternate icon" />
        </a>
      </div>

    </div>
  </div>

</template>

<script>
import axios from 'axios';

export default {

  name: 'CreateKhatma',
  data: () => ({

    ehdaa: ''

  }),
  methods: {

    async createKhatma() {

      if (!this.ehdaa.trim()) {

        alert('يرجى إدخال إهداء الختمة');
        return;

      }

      if (confirm(`هل تريد إنشاء ختمة تهدى إلى: ${this.ehdaa}؟`)) {

        try {

          const result = await axios.post(`${process.env.VUE_APP_BASE_URL}/khatmat`, {

            ehdaa: this.ehdaa

          });

          this.$gtag.event('Create', {

            event_category: 'Khatmat',
            event_label: this.ehdaa

          });

          window.location = `/khatmat/${result.data}`;

        } catch (err) {

          alert(err);

        }

      }

    }

  }

}
</script>

<style lang="scss" scoped>
input {
  text-align: center !important;
}

.label {
  background-color: white !important;
  color: #3c8c45 !important;

  box-shadow: 0 0 0 0.08em #3c8c45 !important;

  i {
    margin: 0 0 0 0.5em !important;
  }
}
</style>
